"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _rsuiteNotification = require("rsuite-notification");

var _Icon = _interopRequireDefault(require("./Icon"));

var _constants = require("./utils/constants");

var _prefix = require("./utils/prefix");

var defaultOptions = {
  classPrefix: (0, _prefix.getClassNamePrefix)() + "notification"
};

_rsuiteNotification.Alert.config(defaultOptions);

function appendIcon(type, content) {
  return React.createElement("div", null, React.createElement(_Icon["default"], {
    icon: _constants.STATUS_ICON_NAMES[type]
  }), content);
}

appendIcon.handledProps = [];

function proxy(type) {
  return function (content, duration, onClose) {
    _rsuiteNotification.Alert[type](appendIcon(type, content), duration, onClose);
  };
}

var _default = {
  info: proxy('info'),
  success: proxy('success'),
  warning: proxy('warning'),
  error: proxy('error'),
  config: function config(options) {
    _rsuiteNotification.Alert.config((0, _extends2["default"])({}, defaultOptions, options));
  }
};
exports["default"] = _default;